import { Component } from '@angular/core';
import { LeadTaskService } from '../../lead-task.service';
import { MatSelectModule } from '@angular/material/select';
import {
  NOT_POSSIBLE_REASONS,
  NotPossibleReason,
} from '../../../../examinationResult.model';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { GeneralInformationService } from '../general-information.service';

@Component({
  selector: 'app-examination-not-possible',
  imports: [MatSelectModule, FormsModule, TranslatePipe],
  templateUrl: './examination-not-possible.component.html',
  styleUrl: './examination-not-possible.component.scss',
})
export class ExaminationNotPossibleComponent {
  reason: NotPossibleReason | undefined = undefined;
  constructor(
    private leadTaskService: LeadTaskService,
    private generalInformationService: GeneralInformationService,
  ) {}

  protected readonly NOT_POSSIBLE_REASONS = NOT_POSSIBLE_REASONS;

  updateNotPossibleReason(reason: NotPossibleReason) {
    this.leadTaskService.setNotPossibleReason(reason);
    this.generalInformationService.setCompletelyClosed(reason);
  }
}
